import "../styles/Badge.css";

export function Badge(props) {
    return <div className={"badge" + (props.className ? (" " + props.className) : "")}>
        {props.icon}
        <span>{props.children}</span>
    </div>
}
